import { render } from "./DocumentFieldSelect.vue?vue&type=template&id=4148532a"
import script from "./DocumentFieldSelect.vue?vue&type=script&lang=js"
export * from "./DocumentFieldSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__